import { Component, ReactNode } from "react";
import { StyledIconPocketMobile } from "../../styles/styles";

export default class IconPocketMobile extends Component {
  render(): ReactNode {
    return (
      <StyledIconPocketMobile>
        <svg
          width="77"
          height="15"
          viewBox="0 0 77 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1686 7.44892C15.1686 11.5644 11.7733 14.9008 7.5843 14.9008C3.39525 14.9008 0 11.5644 0 7.44892C0 3.33411 3.39525 -0.00225067 7.5843 -0.00225067C11.7733 -0.00225067 15.1686 3.33411 15.1686 7.44892ZM7.65459 11.0371C5.67651 11.0371 4.07331 9.46134 4.07331 7.51798C4.07331 5.57462 5.67651 3.99956 7.65459 3.99956C9.63267 3.99956 11.2359 5.57462 11.2359 7.51798H9.93371C9.93371 6.28123 8.91343 5.27886 7.65459 5.27886C6.39574 5.27886 5.37546 6.28123 5.37546 7.51798C5.37546 8.75472 6.39574 9.7571 7.65459 9.7571V11.0371ZM7.65459 1.65372C4.35802 1.65372 1.68556 4.27928 1.68556 7.51798C1.68556 10.7567 4.35802 13.3829 7.65459 13.3829V11.9167C5.18234 11.9167 3.17799 9.94753 3.17799 7.51798C3.17799 5.08913 5.18234 3.11996 7.65459 3.11996C10.1275 3.11996 12.1312 5.08913 12.1312 7.51798H13.6236C13.6236 4.27928 10.9511 1.65372 7.65459 1.65372Z"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0408 3.48477V11.5993H21.869V9.26951H22.3298C24.0999 9.26951 25.3857 8.40037 25.3857 6.30215C25.3857 4.42367 24.3001 3.48477 22.283 3.48477H20.0408ZM23.5688 6.35935C23.5688 7.34498 23.1321 7.80885 22.2588 7.80885H21.8577V4.96845H22.283C23.1321 4.96845 23.5688 5.3507 23.5688 6.35935Z"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.5618 8.60893C25.5618 10.6604 26.6708 11.7158 28.0638 11.7158C29.4562 11.7158 30.5773 10.6493 30.5773 8.58522C30.5773 6.53374 29.4562 5.46719 28.0752 5.46719C26.6829 5.46719 25.5618 6.53374 25.5618 8.60893ZM27.1905 8.58522C27.1905 7.44962 27.5207 6.89297 28.0518 6.89297C28.5942 6.89297 28.9485 7.44962 28.9485 8.59708C28.9485 9.73338 28.6063 10.3012 28.0752 10.3012C27.5327 10.3012 27.1905 9.73338 27.1905 8.58522Z"
            fill="#5A668A"
          />
          <path
            d="M33.5847 11.6928C31.9445 11.6928 30.9768 10.5676 30.9768 8.60894C30.9768 6.69558 31.968 5.49022 33.6791 5.49022C34.2222 5.49022 34.6348 5.59415 35.0359 5.74552L34.7761 7.20618C34.4928 7.07853 34.1633 6.9739 33.8204 6.9739C33.0301 6.9739 32.6169 7.64633 32.6169 8.58522C32.6169 9.60573 33.0301 10.2084 33.8445 10.2084C34.1512 10.2084 34.4693 10.1156 34.8116 9.98799L35.0714 11.3914C34.6582 11.5651 34.1157 11.6928 33.5847 11.6928Z"
            fill="#5A668A"
          />
          <path
            d="M37.3954 8.72473V11.6H35.6843V3.24133H37.3954V8.19111L38.7878 5.59485H40.6636L39.0001 8.46943L40.7112 11.6H38.8112L37.3954 8.72473Z"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.9171 5.46719C41.5596 5.46719 40.4854 6.55676 40.4854 8.6201C40.4854 10.9157 41.6775 11.6928 43.1763 11.6928C43.8373 11.6928 44.5331 11.5414 45.1231 11.2519L44.8164 10.0696C44.3329 10.2893 43.8018 10.4288 43.3531 10.4288C42.5983 10.4288 42.1382 10.0229 42.0786 9.19975H45.324V8.65497C45.324 6.5449 44.3563 5.46719 42.9171 5.46719ZM42.9171 6.75416C43.4354 6.75416 43.7074 7.28709 43.7429 8.19111H42.0786C42.1141 7.31011 42.3853 6.75416 42.9171 6.75416Z"
            fill="#5A668A"
          />
          <path
            d="M46.2428 9.80243V6.97389H45.5825V5.59415H46.2428V4.01839H47.9426V5.59415H49.2405V6.97389H47.9426V9.55969C47.9426 10.0577 48.2138 10.2663 48.6739 10.2663C48.8748 10.2663 49.0516 10.2314 49.2405 10.1854V11.5533C48.9806 11.6342 48.615 11.6809 48.1904 11.6809C46.8925 11.6809 46.2428 11.1592 46.2428 9.80243Z"
            fill="#5A668A"
          />
          <path
            d="M54.9857 11.6928C52.8379 11.6928 51.4924 10.3479 51.4924 7.55355C51.4924 4.86452 52.8734 3.392 54.9977 3.392C55.7056 3.392 56.2956 3.53081 56.7557 3.7052L56.4724 5.3514C56.1068 5.20073 55.6822 5.06122 55.1745 5.06122C54.0421 5.06122 53.369 5.94222 53.369 7.53053C53.369 9.16488 54.0066 10.0229 55.21 10.0229C55.6701 10.0229 56.1068 9.90707 56.4845 9.74454L56.7791 11.3447C56.2722 11.5533 55.6467 11.6928 54.9857 11.6928Z"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.1086 9.77942C57.1086 11.0782 57.781 11.6809 58.7367 11.6809C59.3743 11.6809 59.8109 11.4605 60.2597 11.0782L60.4719 11.6H61.9587L61.8288 10.5335V7.53053C61.8288 6.15079 61.1323 5.50208 59.5866 5.50208C58.7963 5.50208 58.0764 5.68762 57.4629 5.93107L57.781 7.20618C58.2532 7.00877 58.7843 6.86996 59.2798 6.86996C59.9167 6.86996 60.1532 7.14828 60.1532 7.65819V7.9944C59.8699 7.93651 59.5397 7.88977 59.2088 7.88977C58.442 7.88977 57.9344 8.06346 57.5929 8.41153C57.2741 8.71357 57.1086 9.19976 57.1086 9.77942ZM60.1532 8.89842V10.3249C59.9288 10.4519 59.681 10.5446 59.4446 10.5446C58.9731 10.5446 58.7019 10.3012 58.7019 9.6985C58.7019 9.39716 58.7729 9.1886 58.9021 9.04909C59.0441 8.92144 59.2443 8.85238 59.5986 8.85238C59.7989 8.85238 59.9877 8.86354 60.1532 8.89842Z"
            fill="#5A668A"
          />
          <path
            d="M64.6718 11.7039C63.8453 11.7039 63.0785 11.4954 62.4175 11.1473L62.7597 9.79128C63.4094 10.1387 64.0576 10.3479 64.6476 10.3479C65.085 10.3479 65.3207 10.1624 65.3207 9.90707C65.3207 9.65247 65.1794 9.53598 64.353 9.21162C63.2084 8.75961 62.6418 8.33062 62.6418 7.32197C62.6418 6.20869 63.4207 5.49022 64.7896 5.49022C65.4854 5.49022 66.123 5.65275 66.701 5.93107L66.3587 7.28709C65.8276 7.02063 65.2852 6.84625 64.7896 6.84625C64.424 6.84625 64.223 6.99761 64.223 7.24106C64.223 7.47264 64.353 7.58843 65.1673 7.91349C66.4539 8.41154 66.9019 8.8754 66.9019 9.82616C66.9019 11.0782 66.0051 11.7039 64.6718 11.7039Z"
            fill="#5A668A"
          />
          <path
            d="M67.8803 9.80243V6.97389H67.2192V5.59415H67.8803V4.01839H69.5793V5.59415H70.8772V6.97389H69.5793V9.55969C69.5793 10.0577 69.8512 10.2663 70.3106 10.2663C70.5115 10.2663 70.6883 10.2314 70.8772 10.1854V11.5533C70.618 11.6342 70.2517 11.6809 69.8271 11.6809C68.5292 11.6809 67.8803 11.1592 67.8803 9.80243Z"
            fill="#5A668A"
          />
          <mask
            id="mask0_0_833"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="71"
            y="5"
            width="5"
            height="7"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M71.2507 5.35419H75.88V11.7828H71.2507V5.35419Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_0_833)">
            <path
              d="M73.6498 11.7039C72.8233 11.7039 72.0565 11.4954 71.3955 11.1473L71.7377 9.79128C72.3874 10.1387 73.0356 10.3479 73.6256 10.3479C74.0623 10.3479 74.2987 10.1624 74.2987 9.90707C74.2987 9.65247 74.1567 9.53598 73.331 9.21162C72.1865 8.75961 71.6199 8.33062 71.6199 7.32197C71.6199 6.20869 72.3987 5.49022 73.7676 5.49022C74.4634 5.49022 75.101 5.65275 75.679 5.93107L75.3368 7.28709C74.8057 7.02063 74.2632 6.84625 73.7676 6.84625C73.402 6.84625 73.2011 6.99761 73.2011 7.24106C73.2011 7.47264 73.331 7.58843 74.1454 7.91349C75.4312 8.41154 75.8792 8.8754 75.8792 9.82616C75.8792 11.0782 74.9832 11.7039 73.6498 11.7039Z"
              fill="#5A668A"
            />
          </g>
        </svg>
      </StyledIconPocketMobile>
    );
  }
}
